import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

const DMP_WMS_URL =
  'https://ags.cuzk.gov.cz/arcgis2/services/dmp/ImageServer/WMSServer';

export function getDmpTileUrl(
  west: number,
  south: number,
  east: number,
  north: number
): string {
  return (
    `${DMP_WMS_URL}?service=WMS&request=GetMap` +
    '&layers=dmp%3AGrayscaleHillshade&styles=&format=image%2Fjpeg' +
    '&transparent=false&version=1.1.1&width=256&height=256&srs=EPSG%3A4326' +
    `&bbox=${west},${south},${east},${north}`
  );
}

export const dmpLayer = () =>
  new TileLayer({
    id: 'dmp-layer',
    getTileData: async ({ bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const result = await fetch(
        getDmpTileUrl(west, south, east, north)
      );
      const data = await parse(result);

      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 0.7,
    renderSubLayers: renderBitmapTileSubLayer,
  });
